import styled from "styled-components";

export const ColumnHeader = styled.div`
    padding: 0.5rem 0;
    text-align : left;
    line-height: 16px;
`;

export const WrappedText = styled.div`
    line-height: 16px;
`;